import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import Container from "../../../Components/ContainerControl";
import { PersonaAccessReportStyled } from "./styles";
import { useResidentials } from "../../../Hooks/useResidentials";
import { getRequestUserInfo } from "../../../Helpers/restClient";
import { TipoCuentas } from "../../../Helpers/Constant";
import { utils } from "../../../Helpers/utils";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { PersonaAccessReportService } from "./PersonaAccessReport.Service";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import { FilterMatchMode } from "primereact/api";
import TableControl from "../../../Components/Controls/TableControl";
import { columnsPersonasAccessReport } from "./settings";

const PersonaAccessReport = () => {
  const { residentials } = useResidentials();
  const [residentialSelected, setResidentialSelected] = useState(null);
  const [personasByResidential, setPersonasByResidential] = useState();
  const [filters, setFilters] = useState({
    persona: "",
    month: "",
  });
  const [loading, setLoading] = useState(false);
  const [personasAccesses, setPersonasAccesses] = useState([]);
  const [filtersTable, setFiltersTable] = useState({
    personCode: { value: null, matchMode: FilterMatchMode.CONTAINS },
    dateIn: { value: null, matchMode: FilterMatchMode.CONTAINS },
    dateOut: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const toast = useRef(null);

  const userInfo = useMemo(() => getRequestUserInfo(), []);
  const canShowResidentialControl = useMemo(() => {
    const account = userInfo.accounts[0];
    const permission = account.accountType;
    return (
      permission === TipoCuentas.administrador ||
      utils.hasPermission("VerTodasLasResidenciales")
    );
  }, [userInfo]);

  const handleChangeResidential = useCallback(async (residential) => {
    setResidentialSelected(residential);
    const response =
      await PersonaAccessReportService.getAllPersoansByResidential(
        residential?.residentialNo
      );

    setPersonasByResidential(response.personas);
  }, []);

  useEffect(() => {
    if (residentialSelected) {
      setFilters({ ...filters, persona: undefined });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [residentialSelected]);

  useEffect(() => {
    if (utils.evaluateArray(residentials)) {
      const account = userInfo.accounts[0];
      let _residentialSelected = residentials.find(
        (x) => x.residentialNo === account.residentialNo
      );

      if (!_residentialSelected) {
        _residentialSelected = residentials[0];
      }

      setResidentialSelected(_residentialSelected);
      handleChangeResidential(_residentialSelected);
    }
  }, [handleChangeResidential, residentials, userInfo]);

  const handleGenerateReport = async () => {
    setLoading(true);

    const request = {
      ...filters,
      personCode: filters?.persona?.personCode,
      month: utils.FormatDate(filters?.month),
    };

    const response = await PersonaAccessReportService.generateReport(request);
    setLoading(false);

    if (response.success) {
      let _personAccesses = [];

      if (utils.evaluateArray(response.personAccesses)) {
        _personAccesses = response.personAccesses.map((x) => ({
          ...x,
          name: filters.persona?.name,
          dateIn: new Date(x.dateIn).toLocaleString(),
          dateOut: !utils.isNullOrEmpty(x.dateOut)
            ? new Date(x.dateOut).toLocaleString()
            : null,
        }));
      }
      setPersonasAccesses(_personAccesses);
      return;
    }

    toast.current.show({
      severity: "warn",
      summary: "Advertencia",
      detail: response.validationErrorMessage,
      life: 3000,
    });
  };

  const handleOnChangeFilters = (event) => {
    setFilters({ ...filters, [event.target.name]: event.value });
  };

  return (
    <Container>
      <Toast ref={toast} position="top-center" />

      <PersonaAccessReportStyled>
        <div className="report-header">
          {/* Grupo de filtros */}
          <div className="filter-group">
            {canShowResidentialControl && (
              <Dropdown
                value={residentialSelected}
                options={residentials}
                onChange={(e) => handleChangeResidential(e.value)}
                optionLabel="name"
                placeholder="Seleccione una Residencial"
                filter
                className="residential-dropdown"
              />
            )}

            {!canShowResidentialControl && <h2>{residentialSelected?.name}</h2>}

            <Dropdown
              value={filters.persona}
              options={personasByResidential}
              onChange={handleOnChangeFilters}
              optionLabel="name"
              name="persona"
              placeholder="Seleccione una Persona"
              filter
              className="residential-dropdown"
            />

            <div className="calendar">
              <label htmlFor="basic">Mes: </label>
              <Calendar
                id="basic"
                name="month"
                value={filters.month}
                onChange={handleOnChangeFilters}
                view="month"
                dateFormat="mm/yy"
              />
            </div>

            <Button
              label={loading ? "Generando..." : "Generar"}
              icon="pi pi-refresh"
              onClick={handleGenerateReport}
              className="generate-button"
              disabled={loading}
              loading={loading}
            />
          </div>

          {/* Información adicional */}
          {!!filters.persona && (
            <div className="info-box">
              <span>
                Nombre: <strong>{filters.persona.name}</strong>
              </span>
              <span>
                Área: <strong>{filters.persona.area || "Sin área"}</strong>
              </span>
            </div>
          )}
        </div>

        {/* Tabla de resultados */}
        <div className="table-container">
          {loading ? (
            <div className="loading-message">Cargando datos...</div>
          ) : (
            <TableControl
              items={personasAccesses}
              title="Accesos por Persona"
              columns={columnsPersonasAccessReport}
              emptyMessage="No hay registros de acceso."
              filter={filtersTable}
              setFilter={setFiltersTable}
              filterFields={Object.keys(filtersTable)}
              isExportExcel={!!filters.persona}
              fileName={`Reporte de Accesos para ${filters.persona?.name}`}
            />
          )}
        </div>
      </PersonaAccessReportStyled>
    </Container>
  );
};

export default PersonaAccessReport;
